// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_ai__Model from "lui.ai/model.js";
import * as Lui_ai__Transcript from "lui.ai/transcript.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_chat_adapter from "./web_chat_adapter.js";
import * as Mapre_web__Web_markdown from "./web_markdown.js";
import * as Mapre_web__Web_scroll_anchor from "./web_scroll_anchor.js";
import * as Mapre_web__Web_tool_view from "./web_tool_view.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function detail_seq(id) {
  if (id.length > 1 && (Caml_string.get(id, 0) === /* 'e' */101 || Caml_string.get(id, 0) === /* 'x' */120)) {
    return Stdlib.int_of_string_opt(Stdlib__String.sub(id, 1, id.length - 1 | 0));
  }
  
}

function render_attachment(a) {
  let tmp;
  if (Lui_ai__Model.is_image(a)) {
    const url = a.url;
    if (url !== undefined) {
      const partial_arg = a.name;
      const partial_arg$1 = a.name;
      const partial_arg$2 = url;
      const partial_arg$3 = 80;
      const partial_arg$4 = 120;
      tmp = (function (param, param$1) {
        return Lui_elements.image(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, /* [] */ 0, param, param$1);
      });
    } else {
      tmp = (function (param, param$1) {
        return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      });
    }
  } else {
    tmp = (function (param, param$1) {
      return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    });
  }
  const url$1 = a.url;
  let tmp$1;
  if (url$1 !== undefined) {
    const partial_arg$5 = "Download " + a.name;
    const partial_arg$6 = a.name;
    const partial_arg$7 = url$1;
    const partial_arg$8 = "attachment-name";
    tmp$1 = (function (param, param$1) {
      return Lui_elements.link(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    });
  } else {
    const partial_arg$9 = a.name;
    const partial_arg$10 = "attachment-name";
    tmp$1 = (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    });
  }
  const partial_arg_1 = {
    hd: tmp$1,
    tl: /* [] */ 0
  };
  const partial_arg$11 = {
    hd: tmp,
    tl: partial_arg_1
  };
  const partial_arg$12 = "attachment-card";
  const partial_arg$13 = 180;
  const partial_arg$14 = 0;
  const partial_arg$15 = 4;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
  };
}

function copy_action(item_signal) {
  const partial_arg = (function (param) {
    Mapre_web__Browser.copy_text(Signal.get(item_signal).text);
  });
  const partial_arg$1 = "Copy message";
  const partial_arg$2 = {
    NAME: "app",
    VAL: "copy"
  };
  const partial_arg$3 = "sm";
  const partial_arg$4 = "ghost";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, partial_arg$2, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$6 = "start";
  const partial_arg$7 = function (param, param$1) {
    return Lui_elements.row(undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
  const partial_arg$8 = Signal.map((function (item) {
    if (Caml_obj.caml_equal(item.kind, /* Assistant */ 1)) {
      return item.text !== "";
    } else {
      return false;
    }
  }), item_signal);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$8, partial_arg$7, param, param$1);
  };
}

function item_class(item) {
  const match = item.kind;
  if (!/* tag */ (typeof match !== "object" && typeof match !== "function")) {
    return "msg-host";
  }
  switch (match) {
    case /* User */ 0 :
      return "msg-user";
    case /* Assistant */ 1 :
      return "msg-assistant";
    case /* Thinking */ 2 :
      return "thought";
    case /* Tool_call */ 3 :
      return "msg-tool";
    case /* Notice */ 4 :
      return "msg-notice";
  }
}

function tool_status(param) {
  if (param === "completed") {
    return /* Completed */ 2;
  } else if (param === "unknown") {
    return /* Unknown */ 4;
  } else if (param === "failed") {
    return /* Failed */ 3;
  } else if (param === "pending") {
    return /* Pending */ 0;
  } else {
    return /* In_progress */ 1;
  }
}

function truncated_row(send, item) {
  const partial_arg = item.text;
  const partial_arg$1 = "muted";
  const partial_arg$2 = (function (param) {
    const seq = detail_seq(item.id);
    if (seq !== undefined) {
      Curry._1(send, {
        TAG: /* Load_detail */ 24,
        _0: seq
      });
      return;
    }
    
  });
  const partial_arg$3 = "sm";
  const partial_arg$4 = "outline";
  const seq = detail_seq(item.id);
  const partial_arg$5 = seq !== undefined ? "Load full event " + String(seq) : "Load full item";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$6 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$7 = 4;
  const partial_arg$8 = 6;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
  };
}

function assistant_body(item_s) {
  const partial_arg = Signal.map((function (item) {
    return item.text;
  }), item_s);
  const partial_arg$1 = Signal.map((function (item) {
    return item.attachments;
  }), item_s);
  const partial_arg$2 = "circle_dot";
  const partial_arg$3 = {
    hd: [
      "aria-label",
      "Streaming"
    ],
    tl: {
      hd: [
        "role",
        "img"
      ],
      tl: /* [] */ 0
    }
  };
  const partial_arg$4 = 10;
  const partial_arg$5 = 10;
  const partial_arg$6 = function (param, param$1) {
    return Lui_elements.icon(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$7 = Signal.map((function (item) {
    return item.streaming;
  }), item_s);
  const partial_arg_0 = function (param, param$1) {
    return Mapre_web__Web_markdown.view(partial_arg, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.keyed(partial_arg$1, (function (a) {
        return a.attachment_id;
      }), Stdlib__String.compare, (function (source) {
        return render_attachment(Signal.sample(source));
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
      }),
      tl: {
        hd: copy_action(item_s),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$8 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$9 = 0;
  const partial_arg$10 = 4;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, param, param$1);
  };
}

function container_attrs(source) {
  return Signal.map((function (m) {
    const s = m.selected;
    const scope = s !== undefined ? s.id : "";
    return {
      hd: [
        "data-chat-list",
        "events"
      ],
      tl: {
        hd: [
          "data-scroll-root",
          "transcript"
        ],
        tl: {
          hd: [
            "data-anchor-scope",
            scope
          ],
          tl: {
            hd: [
              "data-row-count",
              String(Mapre_web__Web_chat_adapter.row_count(m))
            ],
            tl: /* [] */ 0
          }
        }
      }
    };
  }), source);
}

function transcript_el(send, source, viewport) {
  return Lui_ai__Transcript.transcript(undefined, viewport, 8, undefined, undefined, true, (function (param) {
    const item = Signal.get(param);
    if (item.truncated) {
      return truncated_row(send, item);
    }
    const match = item.kind;
    if (!/* tag */ (typeof match !== "object" && typeof match !== "function")) {
      return;
    }
    switch (match) {
      case /* Assistant */ 1 :
        return assistant_body(param);
      case /* Tool_call */ 3 :
        return Mapre_web__Web_tool_view.view(Signal.map((function (item) {
          return Stdlib__Option.map((function (tool) {
            return {
              id: tool.call_id,
              title: tool.title,
              status: tool_status(tool.status),
              input: tool.input,
              output: tool.output
            };
          }), item.tool);
        }), param));
      default:
        return;
    }
  }), render_attachment, item_class, Mapre_web__Web_chat_adapter.attrs_of, "msg-list", undefined, copy_action, undefined, undefined, (function (id) {
    const seq = detail_seq(id);
    if (seq !== undefined) {
      Curry._1(send, {
        TAG: /* Load_detail */ 24,
        _0: seq
      });
      return;
    }
    
  }), (function (item) {
    const seq = detail_seq(item.id);
    if (seq !== undefined) {
      return "Load full event " + String(seq);
    } else {
      return "Load full item";
    }
  }), undefined, true, Caml_option.some(container_attrs(source)), undefined, Signal.map(Mapre_web__Web_chat_adapter.items_of, source), undefined);
}

const at_bottom_slot = Signal.state_slot("mapre-chat-at-bottom");

const force_slot = Signal.state_slot("mapre-chat-anchor-force");

function view(send, source) {
  return function (param, param$1) {
    return Lui_elements.scoped((function (context) {
      const at_bottom = Signal.state_at(context.ui_scheduler, context.ui_state_scope, at_bottom_slot, true);
      const force = Signal.state_at(context.ui_scheduler, context.ui_state_scope, force_slot, 0);
      const viewport = {
        TAG: /* Host_driven */ 0,
        _0: {
          container: "virtual_list",
          at_bottom: at_bottom.state_signal,
          scroll_to: (function (param, param$1) {
            Signal.update(force, (function (n) {
              return n + 1 | 0;
            }));
          })
        }
      };
      const partial_arg_0 = transcript_el(send, source, viewport);
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___001_) {
            const partial_arg = force.state_signal;
            const partial_arg$1 = Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (m) {
              return Stdlib__Option.fold("", (function (s) {
                return s.id;
              }), m.selected);
            }), source));
            return function (param, param$1) {
              return Mapre_web__Web_scroll_anchor.view(partial_arg$1, partial_arg, (function (param) {
                Curry._1(send, /* Load_older */ 2);
              }), (function (pinned) {
                Signal.set(at_bottom, pinned);
              }), param, param$1);
            };
          }), param, param$1);
        }),
        tl: /* [] */ 0
      };
      const partial_arg = {
        hd: partial_arg_0,
        tl: partial_arg_1
      };
      const partial_arg$1 = 0;
      const partial_arg$2 = 0;
      const partial_arg$3 = 0;
      const partial_arg$4 = 1;
      return function (param, param$1) {
        return Lui_elements.stack(undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
      };
    }), param, param$1);
  };
}

export {
  view,
}
/* at_bottom_slot Not a pure module */
